<div class="container">
    <div class="row">
      <div id="loader">
        <!--
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="loading"></div>
        -->
        <lord-icon
          [attr.colors]="whiteMode ? 'primary:#ffffff,secondary:#ffffff' : 'primary:#121331,secondary:#08a88a'"
          src="https://cdn.lordicon.com/kbtmbyzy.json"
          style="width:120px;height:120px"
          trigger="loop"
        ></lord-icon>
      </div>
  
      <p class="spinner-message" *ngIf="message && message !== ''">
        {{message}}
      </p>
    </div>
  </div>